import React from "react";
import { string } from "prop-types";

import { useStore } from "../../utilities/mobx/storeHooks";
import * as S from "./styled";

const HomeClaimCTA = ({ className }) => {
  const { store } = useStore();
  const { uiStore } = store;

  return (
    <S.CTAContainer className={className}>
      <S.CTAText>
        Are you the homeowner? <br /> View your StreetEasy home price estimate.
      </S.CTAText>
      <S.ViewButton onClick={uiStore.openModal}>View</S.ViewButton>
    </S.CTAContainer>
  );
};

HomeClaimCTA.propTypes = {
  className: string
};

HomeClaimCTA.defaultProps = {
  className: ""
};

export default HomeClaimCTA;
